import { Component, Input } from '@angular/core';
import { RecipeLite } from '../../../../../../../shared/models/recipe/recipe-lite.model';
import { DataRefsByKey, MarketingFood, Unit } from '../../../../../../../shared/models/dataref.model';
import { FormGroup } from '@angular/forms';
import { VariantFormGroupModel } from '../variant-step-instructions/variant-step-instructions.component';

@Component({
  selector: 'app-variant-step-informations',
  templateUrl: './variant-step-informations.component.html',
  styleUrls: ['./variant-step-informations.component.scss'],
  standalone: false,
})
export class VariantStepInformationsComponent {
  @Input() variant?: RecipeLite | null;
  @Input() formVariant?: FormGroup<VariantFormGroupModel>;
  @Input() marketingFoods: MarketingFood[] = [];
  @Input() yieldUnits?: DataRefsByKey<Unit> | null;
  @Input() domain = '';
  @Input() market = '';
  @Input() lang = '';
  panelIngredientsState = true;
}
